var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.$slots.header)?_vm._t("header"):_vm._e(),_c('main',{ref:"main",staticClass:"content",style:({ 'height': `calc(100vh - ${_vm.offset}px)` }),on:{"scroll":_vm.debouncedScroll}},[_vm._t("default")],2),(_vm.$slots.footer)?_vm._t("footer"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }